export default function setStreetAction (street) {
    return {
        type: 'SET_STREET',
        payload: street
    }
}